import { FormlyFieldConfig } from '@ngx-formly/core';

export const issueFeedbackFormlyFields: FormlyFieldConfig[] = [
  {
    key: 'title',
    type: 'input',
    props: {
      placeholder: 'Enter title...',
      required: true
    }
  },
  {
    key: 'description',
    type: 'textarea',
    props: {
      placeholder: 'Enter description...',
      rows: 3
    }
  }
];
